//@flow

import styled from "styled-components"
import * as BaseUI from "../UI"

export const TitleText = BaseUI.TitleText

export const TitleDescription = BaseUI.TitleDescription.extend`
  width: 700px;
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background: #a5d9f2;
`

export const Titles = styled.div`
  position: absolute;
  top: 104px;
  left: 54px;
  z-index: 2;
  padding: 2rem;
`

export const Foreground = styled.div`
  position: absolute;
  bottom: 70px;
  left: 760px;
  height: 536px;
  width: 1303px;
  z-index: 3;
`

export const Midground = styled.div`
  position: absolute;
  bottom: 0px;
  left: -80px;
  height: 754px;
  width: 2018px;
  z-index: 1;
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: -40px;
  height: 600px;
  width: 2080px;
  z-index: 0;
`



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/Carpool/UI.js